import React from "react";
import { NavLink } from "react-router-dom";
import pauseIcon from "../../assets/images/pauseIcon.png";

const StoryTitle = (props) => {
  const thumbnailSrc =
    props.thumbnailUrl || `https://stories-for-life.com/thumbnails/${props.id}`;

  return (
    <div>
      <div
        className={`flex justify-between mt-3 items-center text-end ${
          props.watchStatus === "Watched" ? "bg-primaryOpacity" : "bg-white"
        } h-[70px] border rounded-[16px] p-2.5`}
        style={{
          contentVisibility: "auto",
          containIntrinsicSize: "70px",
        }}
      >
        <div></div>
        <div className="flex items-center text-end">
          <div>
            <div className="text-[16px] font-semibold">{props.title}</div>
            <div className="text-[12px] font-semibold text-primary">
              {props.subtitle}
            </div>
          </div>
          <div>
            <div
              className="h-[50px] rounded-[6px] w-[88px] ms-3.5 relative overflow-hidden bg-[#f3f3f3]"
            >
              <img
                src={thumbnailSrc}
                alt={props.title}
                className="h-full w-full object-cover"
                loading={props.priorityThumbnail ? "eager" : "lazy"}
                fetchPriority={props.priorityThumbnail ? "high" : "low"}
                decoding="async"
              />
              <NavLink
                className="absolute inset-0 flex items-center justify-center"
                to={`/story/${props.id}`}
                data-umami-event="Video Started"
                data-umami-event-video-id={props.id}
                data-umami-event-video-order={props.order}
              >
                <img src={pauseIcon} alt="" />
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoryTitle;
